(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ApplicationParameterDialogController', ApplicationParameterDialogController);

    ApplicationParameterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationParameter'];

    function ApplicationParameterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationParameter) {
        var vm = this;
        vm.applicationParameter = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:applicationParameterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.applicationParameter.id !== null) {
                ApplicationParameter.update(vm.applicationParameter, onSaveSuccess, onSaveError);
            } else {
                ApplicationParameter.save(vm.applicationParameter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
